import { createSelector } from '@reduxjs/toolkit'
import { IStore } from 'redux/types'

export const selectInvoice = createSelector(
	(state: IStore) => state.invoice,
	(invoice) => invoice
)
